"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneElement = exports.replaceElement = exports.isValidElement = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
exports.isValidElement = React.isValidElement;
function replaceElement(element, replacement, props) {
    if (!(0, exports.isValidElement)(element)) {
        return replacement;
    }
    return React.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
exports.replaceElement = replaceElement;
function cloneElement(element, props) {
    return replaceElement(element, element, props);
}
exports.cloneElement = cloneElement;
//# sourceMappingURL=reactNode.js.map